<template>
<div class="user_order no-trans" v-loading="loading">
    <div class="order_titles">我的积分</div>
    <div class="user_order_box">
        <div class="jf_info">
            <div class="jf_title">我的积分</div>
            <div class="jf_flex">
                <div class="jf_nums">{{ jf_num }}</div>
                <div class="jf_btns" @click="handle_yq">邀请赚取积分</div>
            </div>
        </div>
        <div class="order_types">
            <div class="lefts">
                <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" @click="handle_type(item)">
                    {{ item.title }}
                </div>
            </div>
            <div class="rights">
                <el-input
                    placeholder="输入商品名称、订单号"
                    v-model="keyword">
                    <div slot="suffix" class="" @click="handle_seach">
                        <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                    </div>
                </el-input>
            </div>
        </div>
        <div class="order_list">
            <div class="order_tabs">
                <div class="tables tab1">来源/用途</div>
                <div class="tables tab2">积分变化</div>
                <div class="tables tab3">日期</div>
                <div class="tables tab4">备注</div>
                <!-- <div class="tables tab5">操作</div> -->
            </div>
            <div class="order_items">
                <div class="items" v-for="(item,index) in order_list" :key="index">
                    <div class="item1">
                        <div class="item1_box1" v-if="item.order">
                            <div class="box1_imgs">
                                <!-- <img src="../../../../assets/img/index/legal/bg1.png" alt=""> -->
                                 <img :src="item.product_info.thumb" alt="">
                            </div>
                            <div class="box1_info">
                                <div class="box1_titles">{{ item.product_info.title }}</div>
                                <div class="box1_no">订单号：{{ item.order.order_sn }}</div>
                            </div>

                        </div>
                        <div class="item1_box2"v-if="!item.order">
                            {{ item.title }}
                        </div>
                    </div>
                    <div class="item2">
                        <span v-if="item.type==1" class="span1">+{{ item.jifen }}</span>
                        <span v-if="item.type==2" class="span2">-{{ item.jifen }}</span>
                    </div>
                    <div class="item3">{{ item.created_at }}</div>
                    <div class="item4">
                        {{ item.title }}
                    </div>
                 
                </div>
            </div>
        </div>
        <div class="pages_box">
            <div class="btns" @click="handle_pages(1)">首页</div>
            <site-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pages.page"
                background
                :page-size="pages.limit"
                layout="prev, pager, next"
                :total="total">
            </site-pagination>
            <div class="btns"  @click="handle_pages(last_page)">尾页</div>
        </div>
    </div>
    <user_jf_pop ref="user_jf_pop"></user_jf_pop>
</div>
</template>
<script>
import { mapState} from 'vuex'
 
import user_jf_pop from '@/components/user_jf/user_jf_pop.vue'//律所
 

export default {
    components: {
        user_jf_pop
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:0,
            type_list:[
                {
                    title:'积分明细',
                    state:0,
                },
                {
                    title:'积分收入',
                    state:1,
                },
                {
                    title:'积分支出',
                    state:2,
                }
                
            ],
            order_list:[],
            jf_num:0,
            last_page:0,
            total:0,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state
            this.pages.page=1
            this.get_list()

        },
        handle_seach(){
            console.log('点击搜索')
            this.pages.page=1
            this.get_list()
        },
        handleSizeChange(e){
            console.log('条数',e)   
            this.pages.page=1
            this.page.limit=3
            this.get_list()         
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        handle_deitial(){
            this.$router.push({
                path:'/user_wt/user_wt_detial',
                query:{

                }
            })
        },
        handle_yq(){
            this.$refs.user_jf_pop.handle_open()
        },
        get_list(){
            this.loading = true
            this.$api("myJifen", {
                keyword:this.keyword,
                type:this.types_ac,
                ...this.pages,
			}, "get").then((res) => {
                this.loading = false
                console.log('我的点评列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.list.data
                    this.total=res.data.list.total
                    this.last_page=res.data.list.last_page
                    this.jf_num=res.data.total
                } else {
                    alertErr(res.msg)
                }
            });
        },



    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .jf_info{
            background-image: url('../../../../assets/img/user_info/user_jf/bg1.png');
            background-size: 100%;
            width: 100%;
            height: 142px;
            margin-bottom: 24px;
            padding: 24px 32px;
            display: flex;
            flex-wrap: wrap;
            align-content: space-between;
            .jf_title{
                width: 100%;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
            }
            .jf_flex{
                width: 100%;
                display: flex;
                align-items: end;
                justify-content: space-between;
                .jf_nums{
                    font-weight: bold;
                    font-size: 42px;
                    color: #FFFFFF;

                }
                .jf_btns{
                    width: 133px;
                    height: 34px;
                    background: rgba(255, 255, 255, 0.78);
                    border-radius: 4px 4px 4px 4px;
                    text-align: center;
                    line-height: 34px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    cursor: pointer;
                }
            }
        }
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                /deep/.el-input{
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 282px;
                        height: 32px;
                    }
                    .el-input__suffix{
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                    }
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list{
            padding-top: 23px;
            .order_tabs{
                width: 1132px;
                height: 44px;
                background: #F5F5F5;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                display: flex;
                align-items:center;
                justify-content: space-between;
                padding: 0 24px;
                .tables{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;

                }
                .tab1{
                    width: 480px;
                    flex-shrink: 0;
                }
                .tab2{
                    width: 210px;
                    flex-shrink: 0;
                }
                .tab3{
                    width: 250px;
                    flex-shrink: 0;
                }
                .tab4{
                    width: 180px;
                    flex-shrink: 0;
                }
                .tab5{
                    width: 160px;
                    flex-shrink: 0;
                }
            }
            .order_items{
                .items{
                    min-height: 64px;
                    border-left: 1px solid #E5E5E5;
                    border-right: 1px solid #E5E5E5;
                    border-bottom: 1px solid #E5E5E5;
                    padding: 20px 24px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .item1{
                        width: 480px;
                        flex-shrink: 0;
                        .item1_box1{
                            display: flex;
                            align-items: center;
                            .box1_imgs{
                                width: 88px;
                                height: 88px;
                                img{
                                    width: 88px;
                                    height: 88px;
                                }
                            }
                            .box1_info{
                                display: flex;
                                flex-wrap: wrap;
                                align-content: space-between;
                                padding:15px 16px;
                                height: 88px;

                                .box1_titles{
                                    width: 100%;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #333333;

                                }
                                .box1_no{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }
                        }
                        .item1_box2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;
                        }
                       
                    }
                    .item2{
                        width: 210px;
                        flex-shrink: 0;
                        .span1{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #FD4C5C;
                        }
                        .span2{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #3BB363;
                        }

                    }
                    .item3{
                        width: 250px;
                        flex-shrink: 0;
                     
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .item4{
                        width: 180px;
                        flex-shrink: 0;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;

                    }
                    .item5{
                         
                    }
                }
            }
            
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .user_order.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .user_order.no-trans .order_titles {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 56px;
        border-radius: 0px 0px 0px 0px;
        padding: 0 16px;
        font-size: 16px;
        line-height: 1.6;
    }
    .user_order.no-trans .user_order_box {
        padding: 16px 16px;
        margin-top: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .user_order.no-trans .user_order_box .jf_info {
        min-height: 0;
        height: auto;
        margin-bottom: 16px;
        padding: 16px 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .jf_info .jf_title {
        font-size: 16px;
    }
    .user_order.no-trans .user_order_box .jf_info .jf_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .jf_info .jf_flex .jf_nums {
        font-size: 24px;
    }
    .user_order.no-trans .user_order_box .jf_info .jf_flex .jf_btns {
        width: 133px;
        height: 34px;
        border-radius: 4px 4px 4px 4px;
        line-height: 34px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types {
        font-size: 14px;
        padding-bottom: 12px;
        margin-right: 16px;
    }
    .user_order.no-trans .user_order_box .order_types .lefts .types_ac {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
        border-radius: 4px 4px 4px 4px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__inner {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 32px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-right: 3px;
    }
    .user_order.no-trans .user_order_box .order_types .rights /deep/ .el-input .el-input__suffix img {
        width: 18px;
    }
    .user_order.no-trans .user_order_box .order_0 {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_0 img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_0 .texts {
        padding-top: 16px;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list {
        padding-top: 16px;
    }
    .user_order.no-trans .user_order_box .order_list .order_tabs {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        gap: 8px;
        padding: 0 16px;
        min-height: 44px;
    }
    .user_order.no-trans .user_order_box .order_list .order_tabs .tables {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_tabs .tab1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_list .order_tabs .tab2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_list .order_tabs .tab3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_list .order_tabs .tab4 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_list .order_tabs .tab5 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items {
        padding: 16px 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 .item1_box1 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 .item1_box1 .box1_imgs {
        width: 88px;
        min-height: 0;
        height: auto;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 .item1_box1 .box1_imgs img {
        width: 88px;
        min-height: 0;
        height: auto;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 .item1_box1 .box1_info {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding: 15px 16px;
        min-height: 0;
        height: auto;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 .item1_box1 .box1_info .box1_titles {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 .item1_box1 .box1_info .box1_no {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item1 .item1_box2 {
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item2 .span1 {
        font-size: 18px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item2 .span2 {
        font-size: 18px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .order_list .order_items .items .item4 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        font-size: 14px;
    }
    .user_order.no-trans .user_order_box .pages_box {
        min-height: 0;
        height: auto;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .user_order.no-trans .user_order_box .pages_box .btns {
        width: 40px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
}
</style>
